import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'

import './index.scss';
import { ReactComponent as SearchIcon } from './searchIcon.svg'
import { SearchInput } from '../../../building-blocks/atoms/dss-searchable-input/dss-searchable-input';

interface IPropsSearchInputDD
{
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
    style: React.CSSProperties;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    isInlineSearchVisible?: boolean;
}

export const SearchInputDropDown = forwardRef((props: IPropsSearchInputDD, ref) =>
{

    const [ value, setValue ] = useState<string>("")

    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(ref, () => (
        {
            focus: () =>
            {
                if (inputRef.current)
                {
                    inputRef.current.focus();
                }
            }
        }
    ))

    useEffect(() =>
    {
        props.onChange(value);
    }, [ value ])

    return (
        <div className={ `search-dd` } style={ props.style }>

            <input
                value={ value }
                onChange={ (e: React.ChangeEvent<HTMLInputElement>) =>
                {
                    setValue(e.target.value)

                }
                }
                onKeyDown={ (e: React.KeyboardEvent<HTMLInputElement>) =>
                {
                    if (props.onKeyDown && (props.isInlineSearchVisible || e.key !== " ")) {
                        props.onKeyDown(e);
                    }
                } }
                placeholder={ props.placeholder }

                ref={ inputRef }
            />
            { !props.isInlineSearchVisible && <SearchIcon className='icon' /> }
        </div>
    )
})


